var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "420px",
        "show-close": false,
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "edit-statement-order-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c("div", { staticClass: "order-info" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("span", [_vm._v("订单号：")]),
          _vm._v(" "),
          _c("b", [_vm._v(_vm._s(_vm.form.orderNo || "-"))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("span", [_vm._v("订单商品金额：")]),
          _vm._v(" "),
          _c("b", [
            _vm._v("￥" + _vm._s(_vm.formatAmount(_vm.orderInfo.orderAmount))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("span", [_vm._v("订单运费：")]),
          _vm._v(" "),
          _c("b", [
            _vm._v("￥" + _vm._s(_vm.formatAmount(_vm.orderInfo.freight))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("span", [_vm._v("订单打包费：")]),
          _vm._v(" "),
          _c("b", [
            _vm._v("￥" + _vm._s(_vm.formatAmount(_vm.orderInfo.packingFee))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "formRef",
          staticClass: "edit-order-form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "140px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "实际结算-运费：",
                prop: "actualSettlementFreight",
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.actualSettlementFreight,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "actualSettlementFreight", $$v)
                  },
                  expression: "form.actualSettlementFreight",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: "实际结算-打包费：",
                prop: "actualSettlementPackingFee",
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.actualSettlementPackingFee,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "actualSettlementPackingFee", $$v)
                  },
                  expression: "form.actualSettlementPackingFee",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }